var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavBarAppComponent'),_c('div',{staticClass:"main-content"},[_c('transition',{attrs:{"css":false},on:{"enter":_vm.enterArtisan,"leave":_vm.leaveArtisan}},[_c('div',{key:this.$route.name,staticClass:"main-container"},[_c('router-view'),(this.$route.name === 'HomePage')?_c('FooterAppComponent'):_vm._e()],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }